<template>
  <div class="notification-stripe__container dea-bg-grey-light">
    <div class="notification-stripe__container-messages-list">
      <NotificationStripe
        v-for="(message, id) in myMessages"
        :key="id"
        :debug="debug"
        :message="message"
        :positions="getPositions(id)"
        @message-close="messageClose"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"; // eslint-disable-line import/no-extraneous-dependencies, import/no-unresolved
import NotificationStripe from "@/components/elements/NotificationStripe";

export default {
  name: "NotificationStripeContainer",
  components: { NotificationStripe },
  props: {
    messages: {
      type: Array,
      required: true,
    },
    role: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      debug: this.$root.config.messages.debug,
      priorityOrder: this.$root.config.messages.priorityOrder,
    };
  },
  computed: {
    myMessages() {
      const ordered = [...this.messages];
      const priorityArray = this.priorityOrder.map(el => el.topic);
      ordered.sort((a, b) => priorityArray.indexOf(a.push.topic) - priorityArray.indexOf(b.push.topic));

      const newMessages = [];
      priorityArray.forEach(topic => {
        const subList = ordered.filter(el => el.push.topic === topic);
        const reference = this.priorityOrder.find(el => el.topic === topic);
        const message = {};
        if (!subList.length) return;

        if (reference.multi.label) {
          message.intro = reference.intro;
          message.icon = reference.icon;
          message.ids = subList.map(el => el.id);
          // FIXME: need to check book_name because it is not passed in every message. Change this when it is fixed.
          message.description =
            subList.length === 1
              ? this.createDescription(
                  reference.single.label,
                  "%NAME%",
                  subList[0].push.book_name ? subList[0].push.book_name : "",
                  reference,
                  subList[0]
                )
              : this.createDescription(reference.multi.label, "%NUM%", subList.length, reference, subList[0]);
          message.cta = subList.length === 1 ? this.getCta(reference, "single") : this.getCta(reference, "multi");
          message.url =
            subList.length === 1
              ? this.getUrl(reference, "single", subList[0].push.time_ids.join())
              : this.getUrl(reference, "multi");
          newMessages.push(message);
        } else {
          subList.forEach(notification => {
            message.intro = reference.intro;
            message.icon = reference.icon;
            message.ids = [notification.id];
            // FIXME: need to check book_name because it is not passed in every message. Change this when it is fixed.
            message.description = this.createDescription(
              reference.single.label,
              "%NAME%",
              notification.push.book_name ? notification.push.book_name : "",
              reference,
              notification
            );
            message.cta = this.getCta(reference, "single");
            message.url = this.getUrl(reference, "single", notification.push.time_ids.join());
            newMessages.push(message);
          });
        }
      });
      return newMessages;
    },
  },
  methods: {
    ...mapActions(["markAsRead"]),
    createDescription(description, target, change, reference, message) {
      let newDescription = description;
      if (reference.source) {
        const role = message.sender_role;
        const label = reference.source[role] ? reference.source[role] : reference.source.default;
        newDescription = newDescription.replace("%SOURCE%", label);
      }
      return newDescription.replace(target, change);
    },
    getCta(reference, type) {
      return reference[type].cta.ALL ? reference[type].cta.ALL : reference[type].cta[this.role];
    },
    getPositions(id) {
      const positions = [];
      if (id === 0) {
        positions.push("first");
      }

      if (id === this.myMessages.length - 1) {
        positions.push("last");
      }

      return positions;
    },
    getUrl(reference, type, book) {
      let response = reference[type].url.ALL ? reference[type].url.ALL : reference[type].url[this.role];
      if (response.indexOf("%BOOK%") > -1) {
        response = response.replace("%BOOK%", book.toString(10));
      }
      return response;
    },
    async messageClose(messageIds) {
      const token = this.$cookies.get(this.$root.config.api.tokenName);

      // https://css-tricks.com/why-using-reduce-to-sequentially-resolve-promises-works/
      messageIds.reduce(async (previousPromise, messageId) => {
        await previousPromise;
        return this.markAsRead({ token, messageId });
      }, Promise.resolve());
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths

$messages-list-width: 80%;

.notification-stripe__container {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: $space-base 0;

  &-messages-list {
    filter: drop-shadow(0 0 $space-xxx-small $dea-color-grey-medium-light);
    width: $messages-list-width;
  }
}
</style>
